import { render, staticRenderFns } from "./player-skin-renderer.vue?vue&type=template&id=4cb7dd45&"
import script from "./player-skin-renderer.vue?vue&type=script&lang=js&"
export * from "./player-skin-renderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports